export const accountCacheKey = {
  getAccount: 'getAccount',
}
